import React from 'react'

const ErrorMessage = ({children,className}) => {
  return (
    <p className={"h-3 text-right text-xs text-red-500 " + {...className}}>{children}</p>
  )
}

export default ErrorMessage